export default "__VITE_ASSET__wJGhhwSO__"